const reasonValidation = (value) => {
  if (!value) {
    return "Please choose an option";
  }
  return null;
};

export default reasonValidation;
